// image-processing-loader
var previousRequest = require("!!../../../../../../node_modules/fox-file-loader/index.js!../../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./style_list_menu.png");
var dir = previousRequest.replace("style_list_menu.png", "")
module.exports = require("!../../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "style_list_menu.png",
	name: "style_list_menu",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/bg/style_list_menu.png
// module id = 1016
// module chunks = 4